import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { IconButton, Tooltip } from '@mui/material';

import { useThemeMode } from '../theme/ThemeModeContext';

export const ThemeModeToggle = () => {
  const { mode, toggle } = useThemeMode();

  return (
    <Tooltip title={mode === 'dark' ? 'Prepnúť na svetlý režim' : 'Prepnúť na tmavý režim'}>
      <IconButton size="small" onClick={toggle} aria-label="Prepnúť farebný režim">
        {mode === 'dark' ? (
          <LightModeOutlinedIcon fontSize="small" />
        ) : (
          <DarkModeOutlinedIcon fontSize="small" />
        )}
      </IconButton>
    </Tooltip>
  );
};
